import React, { Component } from "react"
import axios from "axios"
import moment from "moment"

import styles from "./weather-widget.module.scss"

const API_KEY = "be0fb9b05789b337c97b50f43309a8d2"

export default class WeatherWidget extends Component {
    state = {
        result: null
    }

    componentDidMount() {
        const exclude = (this.props.type === "forecast") ? "minutely,hourly" : "minutely,hourly,daily"

        axios.get("https://api.openweathermap.org/data/2.5/onecall", {
            params: {
                lat: this.props.lat,
                lon: this.props.lng,
                exclude,
                appid: API_KEY,
                units: "metric"
            }
        })
            .then(result => this.setState({ result: result.data }))
            .catch(error => { console.error(error.message) })
    }

    renderForecast() {
        return (
            <>
                {this.renderCurrent()}
                <div className={styles.forecast} >
                    {
                        this.state.result.daily.map(dayWeather => {
                            return (
                                <div className={styles.weatherDayBox} key={dayWeather.dt}>
                                    <div className={styles.weatherDayBox__title}>
                                        {moment.unix(dayWeather.dt).format("dddd")}
                                    </div>
                                    <img
                                        src={`http://openweathermap.org/img/wn/${dayWeather.weather[0].icon}.png`}
                                        alt={dayWeather.weather[0].main}
                                    />
                                    <div className={styles.weatherDayBox__minMax}>
                                        <div>{`${Math.floor(dayWeather.temp.max)}°C`}</div>
                                        <div>{`${Math.floor(dayWeather.temp.min)}°C`}</div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </>
        )
    }

    renderCurrent() {
        const currentWeather = this.state.result.current
        return (
            <div className={styles.currentWeatherBox}>
                <div className={styles.currentWeatherBox__city}>
                    METEO
                </div>
                <div className={styles.currentWeatherIcon}>
                    <img
                        src={`http://openweathermap.org/img/wn/${currentWeather.weather[0].icon}@2x.png`}
                        alt={currentWeather.weather[0].main}
                    />
                </div>
                <div className={styles.currentWeatherBox__temperature}>
                    <div>{`${Math.floor(currentWeather.temp)}°C`}</div>
                </div>
            </div>
        )
    }

    render() {
        if (!this.state.result) return <></>

        return (
            <div className={styles.root}>
                {
                    (this.props.type === "forecast") ? this.renderForecast() : this.renderCurrent()
                }
            </div>
        )
    }
};
